export default {
  Email: '郵箱',
  ConfirmEmail: '確認郵箱',
  Password: '密碼',
  Verificationcode: '驗證碼',
  AlreadyhaveaHitPawaccountLogin: '已經有HitPaw帳戶了？登陸',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
    '註冊即表示您同意我們的使用服務和隱私政策',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
    '登入即表示您同意我們的使用服務和隱私政策',
  Byproceedingyouagreetoour: '註冊或登入即表示您同意我們的',
  ServicesofUse: '使用服務',
  and: '和',
  PrivacyPolicy: '隱私政策',
  last: '。',
  TheEmailformatisincorrect: '郵箱格式不正確',
  Pleaseenterthesameemailinbothfields: '兩次輸入郵箱不一致',
  Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
    '密碼必須為8-50個字元，並且至少包含以下兩類：數字、字母或特殊字元。',
  Incorrectverificationcode: '輸入驗證碼錯誤',
  ThisEmailhasbeenregisteredpleasechooseanother: '郵箱已註冊',
  Cannotbeemptyhere: '此處不能為空',
  Rememberme: '記住密碼',
  ForgotPassword1: '忘記密碼了？',
  NotaregistereduseryetSignUp: '還沒有註冊嗎？註冊',
  Notaregistereduseryet1: '還沒有註冊嗎？',
  Notaregistereduseryet2: '註冊',
  NoaccountfoundwiththatEmailaddress: '郵箱不存在',
  YourEmailaddressorpasswordwasincorrectPleasetryagain:
    '郵箱或密碼錯誤，請重新輸入',
  ForgotPassword2: '忘記密碼',
  GetVerificationCode: '獲取驗證碼',
  VerifyEmail: '驗證郵箱',
  Ithasbeensenttoyourmailboxpleasecheckit: '已發送到您的郵箱，請查收',
  PleaseinputEmailaddress: '請輸入郵箱',
  TheEmailisnotregistered: '該郵箱未註冊',
  Invalidverificationcodepleasereenterthecorrectone: '驗證碼錯誤，請重新輸入',
  Resetpassword: '重置密碼',
  Emailaddressverificationsucceeded: '郵箱驗證成功',
  Pleaseresetyourpassword: '請重新設置密碼',
  Enteranewpassword: '輸入新密碼',
  Confirm: '確認',
  Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
    '新密碼需8-50字元，由英文字母或數字或字母+數字混合組成',
  Passwordresetsuccessfully: '密碼重置成功',
  Name: '名字',
  GetCode: '獲取驗證碼',
  Loginsuccessful: '登入成功',
  Loginfailed: '登入失敗',
  Signupsuccessful: '註冊成功',
  Signupfailed: '註冊失敗',
  Getpassword: '獲取密碼',
  Authorizationhasexpiredpleaseloginagain: '認證資訊過期，請重新登入',
  Sorrysomethingwentwrongpleasetryagainlater: '請求失敗，請稍後再試',
  Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
    '請求太過於頻繁，請稍後再試',
  Couldntfindyouraccountorthepasswordisincorrect:
    '用戶登入，帳號或者密碼不存在',
  Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
    '免費用戶嘗試使用收費功能的提醒',
  Accessdeniedfortheunauthorizedrequest: '用戶訪問了無權限訪問的資源',
  Alreadyhaveaccount: '已經有帳號了？',
  SignUpwithemail: '使用電子郵件注册',
  Securityverification: '安全性驗證',
  Pleaseenterthecorrectemailaddress: '請輸入正確的電子郵寄地址！',
  PleaseInputverificationCode: '請輸入驗證碼！',
  Pleaseenterthesamepasswordinbothfields: '兩次輸入密碼不一致！',
  or: '或',
  ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
    '輸入新密碼與舊密碼一致，請輸入不同的密碼',
  YourpasswordwasincorrectPleasetryagain: '密碼不正確，請再試一遍',
  reg400: '請求失敗，請稍後再試',
  reg400223: '電子郵件和程式碼不匹配，請檢查',
  reg400224: '使用許可已過期',
  500: '服務器端錯誤！',
  Afewsecondsaway: '只需幾秒即可登入或註冊',
  ContinuewithGoogle: '使用Google繼續',
  ContinuewithEmail: '使用Email繼續',
  LoginwithEmail: '使用Email登入',
  Usemorethan8charactersandmixlettersnumbersandsymbols:
    '使用8個以上字元，並混合使用字母，數字及符號（支持符號：@$!%*#_~?&^)',
  ConfirmPassword: '確認密碼',
  Pleaseloginwithemail: '請使用email登入',
  youraccount: '系統檢測到您的賬戶',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    '已存在，為保證您的賬戶安全，請先進行安全驗證。',
  Login: '登入',
  exceed6Times: '您的試用次数今天已用完，請升級到 Pro 以訪問所有高級功能。',
  exceed20M:
    '免費帳戶的文件大小不能超過 20MB，請升級到 Pro 以訪問所有高級功能。',
  403102: 'Google账号已被其他账号绑定',
};
